<template>
  <v-row class="campo-telefone px-3">
    <v-col
      v-for="(telefone, index) in telefones"
      :key="telefone._key"
      cols="12"
      class="campo-telefone__item"
    >
      <v-row dense align="center">
        <v-col cols="12" md="5" class="campo-telefone__phone">
          <v-text-field-simplemask
            v-model="telefone.fone"
            v-bind:label="$t('Telefone') + ' - ' + (index + 1)"
            v-bind:properties="phoneInputProperties"
            v-bind:options="phoneInputOptions"
            v-on:input="emitTelefones"
            v-on:blur="emitTelefones"
          />
        </v-col>

        <v-col cols="12" md="5">
          <v-text-field
            v-model="telefone.descricao"
            :label="$t('Descricao') + ' - ' + (index + 1)"
            :name="'telefoneDescricao' + (index + 1)"
            clearable
            @input="emitTelefones"
            @blur="emitTelefones"
          />
        </v-col>

        <v-col cols="12" md="2" class="campo-telefone__actions">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                small
                color="error"
                v-bind="attrs"
                v-on="on"
                :aria-label="$t('Remover')"
                :disabled="telefones.length === 1 && !hasTelefone(telefone)"
                @click="removeFone(index)"
              >
                <v-icon small>mdi-trash-can-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("Remover") }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-col>

    <v-col cols="12" class="campo-telefone__footer">
      <v-btn
        class="
          ma-1
          font-weight-bold
          text-none
          btn-primary
          bg-gradient-primary
          py-3
          px-6
        "
        @click="addFone"
      >
        <v-icon left dark>mdi-plus-circle</v-icon>
        {{ $t("Adicionar") }} {{ $t("Telefone").toLowerCase() }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "CampoTelefone",

  props: {
    payloadTelefones: {
      type: Array,
      required: false,
      default() {
        return [{ fone: "", descricao: "" }];
      },
    },
  },

  data() {
    return {
      internalUpdate: false,
      nextKey: 1,
      telefones: [{ fone: "", descricao: "", _key: 0 }],
      phoneInputProperties: {
        prefix: "",
        suffix: "",
        readonly: false,
        disabled: false,
        outlined: false,
        clearable: true,
        placeholder: "",
      },
      phoneInputOptions: {
        inputMask: "(##) #####-####",
        outputMask: "###########",
        empty: null,
        applyAfter: false,
        alphanumeric: false,
        lowerCase: false,
      },
    };
  },

  watch: {
    payloadTelefones(value) {
      if (!this.internalUpdate) {
        this.setTelefones(value);
      }
    },
  },

  mounted() {
    this.setTelefones(this.payloadTelefones);
  },

  methods: {
    newTelefone(telefone = {}) {
      return {
        ...telefone,
        fone: telefone.fone || "",
        descricao: telefone.descricao || "",
        _key: this.nextKey++,
      };
    },

    setTelefones(telefones) {
      const telefonesValidos = Array.isArray(telefones) ? telefones : [];
      this.telefones = telefonesValidos.length
        ? telefonesValidos.map((telefone) => this.newTelefone(telefone))
        : [this.newTelefone()];
    },

    onlyDigits(value) {
      return value !== null && value !== undefined
        ? String(value).replace(/\D/g, "")
        : "";
    },

    hasTelefone(telefone) {
      return Boolean(
        this.onlyDigits(telefone.fone) ||
          (telefone.descricao && String(telefone.descricao).trim())
      );
    },

    getTelefonesNormalizados() {
      return this.telefones
        .map((telefone) => {
          const fone = this.onlyDigits(telefone.fone);
          if (!fone) {
            return null;
          }

          const telefoneNormalizado = {
            ...telefone,
            fone,
            descricao:
              telefone.descricao && String(telefone.descricao).trim()
                ? String(telefone.descricao).trim()
                : null,
          };
          delete telefoneNormalizado._key;
          return telefoneNormalizado;
        })
        .filter(Boolean);
    },

    emitTelefones() {
      this.internalUpdate = true;
      this.$emit("telefones", this.getTelefonesNormalizados());
      this.$nextTick(() => {
        this.internalUpdate = false;
      });
    },

    focusTelefone(index) {
      const input = this.$el.querySelectorAll(".campo-telefone__phone input")[
        index
      ];
      if (input) {
        input.focus();
      }
    },

    addFone() {
      this.telefones.push(this.newTelefone());
      this.emitTelefones();
      this.$nextTick(() => this.focusTelefone(this.telefones.length - 1));
    },

    removeFone(index) {
      if (this.telefones.length === 1) {
        this.$set(this.telefones, 0, this.newTelefone());
      } else {
        this.telefones.splice(index, 1);
      }
      this.emitTelefones();
    },
  },
};
</script>

<style scoped>
.campo-telefone {
  width: 100%;
}

.campo-telefone__item {
  padding-bottom: 0;
  padding-top: 0;
}

.campo-telefone__actions {
  align-items: center;
  display: flex;
  justify-content: flex-start;
  padding-top: 18px;
}

.campo-telefone__footer {
  display: flex;
  justify-content: flex-start;
  padding-top: 0;
}

@media (max-width: 959px) {
  .campo-telefone__actions {
    justify-content: flex-end;
    padding-top: 0;
  }
}
</style>
